import styled, { css } from 'styled-components';

type TStatus = {
  status?: string;
  small?: boolean;
};

type TStatusWrapper = {
  statusName: string;
  small?: boolean;
};

const StatusWrapper = styled.span<TStatusWrapper>(
  ({ theme, statusName, small }) => css`
    color: ${theme.colors.generalStatuses[statusName].text};
    background-color: ${theme.colors.generalStatuses[statusName].background};
    border: 2px solid ${theme.colors.generalStatuses[statusName].background};
    transition: background-color 0.35s ease, opacity 0.35s ease;
    padding: 0.125rem 0.5rem;
    word-break: normal;

    ${small &&
    css`
      font-size: ${theme.fonts.sizes.h6};
    `}
  `
);

const GeneralStatus = ({ status, small }: TStatus) => {
  let statusText = null;
  let statusName = null;
  switch (status) {
    case 'ACTIVE':
      statusName = 'active';
      statusText = 'Active';
      break;
    case 'INACTIVE':
      statusName = 'inactive';
      statusText = 'Inactive';
  }

  return (
    <>
      {statusName !== null && (
        <StatusWrapper
          className="status-wrapper"
          statusName={statusName}
          small={small}
        >
          {statusText}
        </StatusWrapper>
      )}
    </>
  );
};

export { GeneralStatus };
